// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { ToolbarItem } from '@progress/kendo-vue-buttons';
import { getDefaultSlots } from '@progress/kendo-vue-common';
import { ViewSelectorList } from './ViewSelectorList';
/**
 * @hidden
 */
var SchedulerViewSelectorVue2 = {
  name: 'KendoSchedulerViewSelector',
  props: {},
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    return (
      // @ts-ignore  function children
      h(ToolbarItem
      // ref={(item) => { if (item) { element.current = item.element; } }}
      , {
        "class": 'k-scheduler-views'
      }, this.v3 ? function () {
        return [h(ViewSelectorList)];
      } : [h(ViewSelectorList)])
    );
  }
};
/**
 * @hidden
 */
var SchedulerViewSelector = SchedulerViewSelectorVue2;
export { SchedulerViewSelector, SchedulerViewSelectorVue2 };